<template>
  <div class="sm-report-org">
    <div style="position: relative">
      <div
        :ref="'wrapper'"
        :class="{ 'hide-arrow': !allowExpand }"
        class="sm-dynamic-table-wrapper"
        @scroll.prevent="handleScroll"
      >
        <!-- :class="{ center: showScroll }" -->
        <div :ref="'table'" class="sm-dynamic-table">
          <div
            class="sm-dynamic-table-item header"
            :class="{ open: allowExpand && allRowsExpanded }"
          >
            <div class="sm-dynamic-table-item-row">
              <div
                class="sm-dynamic-table-item-row-th sticky-col"
                @click.prevent="allRowsExpanded = !allRowsExpanded"
                title="Expand/Collapse rows"
              >
                <include-svg v-show="allowExpand" :name="'icon-arrow-b-big'" />
              </div>
              <div
                class="sm-dynamic-table-item-row-th sticky-col"
                :style="{ 'min-width': titleWidth + 'px' }"
              >Product/Customer name</div>
              <div
                v-for="head in heads"
                :key="head"
                class="sm-dynamic-table-item-row-th sm-txt-center"
              >
                <text-truncate
                  :text="head"
                  :classes="'uppercase sm-txt-strong'"
                />
              </div>
              <div class="sm-dynamic-table-item-row-th sm-txt-right">Total</div>
            </div>
          </div>
          <org-admin-reports-item
            v-for="(item, index) in currReport"
            :key="index"
            :item="item"
            :heads="heads"
            :viewPort="viewPort"
            :allRowsExpanded="allRowsExpanded"
            :allowExpand="allowExpand"
            :priceFormat="item.title === 'Current number of active customers' ? false : priceFormat"
            :titleWidth="titleWidth"
          />
        </div>
        <div
          v-show="showLFI"
          class="sm-dynamic-table-freeze-indicator left"
        ></div>
        <div
          v-show="showRFI"
          class="sm-dynamic-table-freeze-indicator right"
        ></div>
        <div class="scrollbar-gradient"></div>
        <div
          v-show="showScroll && viewPort === 'large'"
          class="scrollbar wrapper"
        >
          <div></div>
        </div>
        <div
          v-show="showScroll && viewPort === 'large'"
          class="scrollbar"
          :ref="'scrollbar'"
        >
          <div
            :ref="'thumb'"
            :style="{ left: scrollX + 'px', width: thumbWidth + 'px' }"
            class="scrollbar-thumb"
            @mousedown="fakeScroll"
          >
            <include-svg :name="'icon-scrollbar-thumb-dashes'" />
          </div>
        </div>
      </div>
    </div>
    <sm-spinner :isGlobal="true" :show="showSpinner" />
  </div>
</template>

<script>
import Spinner from "@/components/Spinner";
import { mapActions, mapGetters } from "vuex";
import { FormatPrice } from "@/utils/general-data";
import ViewPort from "@/mixins/ViewPort";
import TableItem from "@/views/admin/pages/reports/components/org-admin-reports/TableItem";

export default {
  name: "org-admin-reports-table",
  components: {
    "sm-spinner": Spinner,
    "org-admin-reports-item": TableItem,
  },
  props: {
    report: {
      type: Array,
      required: true,
    },
    allowExpand: {
      type: Boolean,
      default: true,
    },
    priceFormat: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      allowedBreakpoints: ["tiny", "medium", "large"],
      currReport: [],
      heads: [],
      showSpinner: false,
      allRowsExpanded: false,
      showLFI: false,
      showRFI: false,
      scrollX: 0,
      thumbWidth: 100,
      showScroll: false,
      titleWidth: 210,
      minTitleWidth: 210,
    };
  },
  computed: {
    ...mapGetters({
      isMobile: "isMobile",
    }),
  },
  created() {
    window.addEventListener("resize", () => this.handleReportChange(this.report));
  },
  destroyed() {
    window.removeEventListener("resize", () => this.handleReportChange(this.report));
  },
  mounted() {},
  mixins: [ViewPort],
  methods: {
    ...mapActions({
      getDetails: "reports/getDetails",
      getDetailsCSV: "reports/getDetailsCSV",
    }),
    formatPrice: FormatPrice,
    prepateItems(arr) {
      return arr.map((item) => {
        return {
          ...item,
          isOpen: false,
        };
      });
    },
    toggleItem(item) {
      item.isOpen = !item.isOpen;
      this.currReport = [...this.currReport];
    },
    handleScroll(e) {
      const wrapperWidth = this.$refs.wrapper.clientWidth;
      const tableWidth = this.$refs.table.clientWidth;

      const left = e && e.type === "scroll" && e.target ? e.target.scrollLeft : 0;

      this.showLFI = left > 0;
      this.showRFI =
        tableWidth > wrapperWidth && left < tableWidth - wrapperWidth;

      this.scrollX =
        (left *
          (this.$refs.scrollbar.clientWidth - this.$refs.thumb.clientWidth)) /
        (tableWidth - wrapperWidth);
    },
    buttonPressed(event) {
      if (event.buttons == null) return event.which != 0;
      else return event.buttons != 0;
    },
    moved(event) {
      if (!this.buttonPressed(event)) {
        removeEventListener("mousemove", this.moved);
      } else {
        const wrapper = this.$refs.wrapper;
        const thumbWidth = this.$refs.thumb.offsetWidth;
        const scrollbarWidth = this.$refs.scrollbar.offsetWidth;
        const tableWidth = this.$refs.table.clientWidth;
        const maxScrollX = scrollbarWidth - thumbWidth;
        const distX = event.pageX - this.$refs.scrollbar.offsetLeft;
        this.scrollX = Math.min(
          maxScrollX,
          Math.max(0, distX - 0.5 * thumbWidth)
        );
        if(wrapper) wrapper.scrollLeft =
          (this.scrollX / (scrollbarWidth - thumbWidth)) *
          (tableWidth - wrapper.clientWidth);
      }
    },
    fakeScroll(event) {
      if (event.which == 1) {
        addEventListener("mousemove", this.moved);
        event.preventDefault(); // Prevent selection
      }
    },
    handleReportChange(val) {
      if (val.length) {
        this.titleWidth = this.minTitleWidth;
        this.allRowsExpanded = false;
        this.currReport = [...val];
        const filterArr = ["title", "total", "details"];
        const items = [...Object.keys(val[0])].filter(
          (item) => !filterArr.includes(item)
        );
        this.heads = items;
        this.sortDesc = true;
        this.scrollX = 0;
        if(this.$refs.wrapper) this.$refs.wrapper.scrollLeft = 0;
        setTimeout(() => {
          const wrapperWidth = this.$refs.wrapper.clientWidth;
          const tableWidth = this.$refs.table.clientWidth;

          const availableSpace = wrapperWidth - (tableWidth - this.titleWidth);

          this.titleWidth =
            availableSpace > this.minTitleWidth
              ? availableSpace
              : this.minTitleWidth;

          this.showScroll = tableWidth > wrapperWidth;

          this.handleScroll();
        }, 100);
      }
    }
  },
  watch: {
    report(val) {
      this.handleReportChange(val);
    },
    viewPort: {
      immediate: true,
      handler(val) {
        this.minTitleWidth = val === "tiny" ? 150 : 210;
      },
    },
  },
};
</script>

<style lang="scss">
@use "@/assets/scss/general/mixins.scss" as *;
@use "@/assets/scss/framework/scss-variables.scss" as *;
</style>
